import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { sendPostViewAnalytics } from '../transport';
export function closureTrackBlockShow() {
  var wasShowEventSent = {};
  return function (_ref) {
    var analyticsData = _ref.analyticsData,
      bannerSource = _ref.bannerSource,
      offerType = _ref.offerType;
    if (!wasShowEventSent[analyticsData.banner.place]) {
      sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
        bannerSource: bannerSource,
        offerType: offerType
      }), 'show');
      wasShowEventSent[analyticsData.banner.place] = true;
    }
  };
}
export var trackBlockShow = closureTrackBlockShow();